import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchVehicledetails } from './vehicledetailsAPI'; // Assume this API function accepts filters as a parameter.
import { act } from 'react';

const initialState = {
  data: {},
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  failedVins: {}, // Track VINs that failed so we don't retry them
};


// Async thunk to fetch data with filters
export const fetchVehicledetailsDataWithFilters = createAsyncThunk(
  'vehicledetails/fetchVehicledetailsDataWithFilters',
  async ({ filter = {}, options = {} }, { rejectWithValue }) => {
    const response = await fetchVehicledetails({ filter, options });
    if (!response || !response.data) {
      return rejectWithValue(`No vehicle details for VIN ${filter.vin}`);
    }
    return response.data;
  }
);

export const VehicledetailsSlice = createSlice({
  name: 'vehicledetails',
  initialState,
  reducers: {}, 
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicledetailsDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchVehicledetailsDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data[action.payload?.vin || 0] = action.payload; // Store the fetched data
      })
      .addCase(fetchVehicledetailsDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message || action.payload;
        // Track the failed VIN so we don't retry it
        const vin = action.meta?.arg?.filter?.vin;
        if (vin) {
          state.failedVins[vin] = true;
        }
      });
  },
});

// Selector to access the data and status
export const selectVehicledetailsData = (state) => state.vehicledetails.data;
export const selectVehicledetailsStatus = (state) => state.vehicledetails.status;
export const selectVehicledetailsError = (state) => state.vehicledetails.error;
export const selectVehicledetailsFailedVins = (state) => state.vehicledetails.failedVins;

export default VehicledetailsSlice.reducer;
